<template>
  <home-base-rail :label="label" variant="ranking">
    <home-ranking-card
      v-for="project in items"
      :key="project.id"
      :project="project"
      :show-views="showViews"
    />
  </home-base-rail>
</template>

<script>
import HomeBaseRail from "./HomeBaseRail.vue";
import HomeRankingCard from "@/components/home/cards/HomeRankingCard.vue";

export default {
  name: "HomeRankingRail",
  components: { HomeBaseRail, HomeRankingCard },
  props: {
    items: { type: Array, default: () => [] },
    label: { type: String, default: "ranking" },
    showViews: { type: Boolean, default: true },
  },
};
</script>
